import { FC, memo } from "react";
import styled from "styled-components";

type Direction = "top" | "bottom" | "right";

type Props = {
  direction?: Direction;
};

const ChevronSpan = styled("span")`
  &::before {
    border-style: solid;
    border-width: 0.25em 0.25em 0 0;
    content: "";
    display: inline-block;
    height: 0.45em;
    left: 0.15em;
    position: relative;
    top: 0.5em;
    transform: rotate(-45deg);
    vertical-align: top;
    width: 0.45em;
  }
`;

const Top = styled(ChevronSpan)`
  &::before {
    top: 0.45em;
  }
`;

const Bottom = styled(ChevronSpan)`
  &::before {
    top: 0.15em;
    transform: rotate(135deg);
  }
`;

const Right = styled(ChevronSpan)`
  &::before {
    transform: rotate(45deg);
  }
`;

const Chevron: FC<Props> = ({ direction }) => {
  if (direction === "bottom") {
    return <Bottom />;
  }

  if (direction === "right") {
    return <Right />;
  }

  return <Top />;
};

export default memo(Chevron);
